<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <h2 class="text-center">Sign In</h2>

        <p v-if="$route.query.redirect" class="error text-center">
          You need to sign in first to proceed.
        </p>
        <p v-if="error" class="error">
          {{ error }}
        </p>
        <form @submit.prevent="signIn" autocomplete="off">
          <div class="form-group">
            <input
              v-model.trim="email"
              class="form-control"
              autofocus
              placeholder="Email"
              required
            />
          </div>
          <div class="form-group">
            <input
              v-model.trim="password"
              class="form-control"
              placeholder="Password"
              type="password"
              required
            />
          </div>
          <button type="submit" class="btn btn-black btn-block">
            Sign In
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      error: "",
    };
  },
  methods: {
    signIn() {
      this.$store
        .dispatch("signIn", {
          email: this.email,
          password: this.password,
        })
        .then(() => {
          this.$router.replace(this.$route.query.redirect || "/landing");
        })
        .catch((error) => {
          this.error = error;
          if(error === undefined) {
            this.error = "There was a problem signing you in. Please check your login credentials and try again.";
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
form {
  margin-top: 1rem;
}
.error {
  color: $error-color;
  text-align: center;
}
</style>
